// extracted by mini-css-extract-plugin
export default {"form":"NewCommentForm_form__avR3P","loading":"NewCommentForm_loading__xInlU","control":"NewCommentForm_control__h3Iq7","actions":"NewCommentForm_actions__mZQ5y"};